import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import { Column } from "primereact/column";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import NewSubcategory from "../NewSubcategory/NewSubcategory";
import CategoryService from "../../../../service/CategoryService";
import { Button } from "primereact/button";
import { locale } from "../../../../utilities/locale/locale";
import SubcategoriesService from "../../../../service/SubcategoriesService";
import { FilterMatchMode } from "primereact/api";

import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";

const ListSubcategories = () => {
  const [loading, setLoading] = useState(false);
  const [subcategories, setSubcategories] = useState([]);

  const [isEdit, setIsEdit] = useState(false);
  const [descriptionEnglish, setDescriptionEnglish] = useState("");
  const [descriptionItalian, setDescriptionItalian] = useState("");
  const [descriptionPortuguese, setDescriptionPortuguese] = useState("");
  const [descriptionSpanish, setDescriptionSpanish] = useState("");
  const [id, setId] = useState("");
  const [imageid, setImageid] = useState("");
  const [isService, setIsService] = useState(false);
  const [selectedCategoryState, setSelectedCategoryState] = useState({});

  const categoryService = new CategoryService();
  const subcategoriesService = new SubcategoriesService();
  const toast = useRef(null);
  const newSubCategoryRef = useRef(null);

  useEffect(() => {
    let cancel = false;

    async function fetchData() {
      try {
        setLoading(true);

        const res = await subcategoriesService.getSubcategories(
          localStorage.getItem("__extraconomy_token")
        );

        if (cancel) return;

        if (res.messageCode !== 200001) {
          toast.current.show({
            severity: "error",
            summary: localeText("error"),
            detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
            life: 6000,
          });
          if (res.messageCode === 500000) console.log(res);
          setLoading(false);
        } else {
          setSubcategories(res.result);
          setLoading(false);
        }
      } catch (e) {
        if (e.status === 401 || e.status === 403) {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }
        setLoading(false);
        console.log(e);
      }
    }

    fetchData();

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const findCategoryToSubcategory = async (selectedId) => {
    const { result: categories } = await categoryService.getCategories();
    const selectedCategory = categories.find((Arraycategory) => {
      // console.log(Arraycategory.id, ' === ', selectedId)
      const { subCategories: subCategoriesArray } = Arraycategory;
      return subCategoriesArray.some(
        (subCategoriesArrayElement) => subCategoriesArrayElement.id === selectedId
      );
    });

    let description = "";

    switch (locale) {
      case "pt":
        description = selectedCategory.descriptionPortuguese;
        break;
      case "it":
        description = selectedCategory.descriptionItalian;
        break;
      case "es":
        description = selectedCategory.descriptionSpanish;
        break;
      default:
        description = selectedCategory.descriptionEnglish;
        break;
    }

    setSelectedCategoryState({ label: description, id: selectedCategory.id });
  };

  const filters2 = {
    "subcategories.descriptionEnglish": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "subcategories.descriptionItalian": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "subcategories.descriptionSpanish": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "subcategories.descriptionPortuguese": { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  return (
    <div className="card border-1 border-300">
      <Toast ref={toast} />

      <h3 className="my-4">{localeText("subcategoriesRegistered")}</h3>

      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={subcategories}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={localeText("image")}
          body={(subcategory) => {
            return (
              <Link to={`/subcategory?id=${subcategory.id}`}>
                <AdvancedImage
                  cldImg={cloudinaryInstance
                    .image(subcategory.imageid)
                    .resize(fill().width(600).height(600))
                    .format("webp")}
                  height={75}
                  style={{ border: "1px solid #E0E0E0" }}
                  className="border-round product-thumbnail"
                />
              </Link>
            );
          }}
          style={{ width: "20%" }}
        />
        <Column
          header={localeText("descriptionSubcategoryEN")}
          field="descriptionEnglish"
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "16%" }}
          body={(subcategory) => {
            return <span>{subcategory.descriptionEnglish}</span>;
          }}
        />
        <Column
          header={localeText("descriptionSubcategoryIT")}
          field="descriptionItalian"
          filter
          filters={filters2}
          filterDisplay="row"
          style={{ width: "16%" }}
          body={(subcategory) => {
            return <span>{subcategory.descriptionItalian}</span>;
          }}
        />
        <Column
          field="descriptionPortuguese"
          filter
          filters={filters2}
          filterDisplay="row"
          header={localeText("descriptionSubcategoryPT")}
          style={{ width: "16%" }}
          body={(subcategory) => {
            return <span>{subcategory.descriptionPortuguese}</span>;
          }}
        />
        <Column
          field="descriptionSpanish"
          filter
          filters={filters2}
          filterDisplay="row"
          header={localeText("descriptionSubcategoryES")}
          style={{ width: "16%" }}
          body={(subcategory) => {
            return <span>{subcategory.descriptionSpanish}</span>;
          }}
        />
        {/**
       <Column field='service' header={localeText('service')} style={{ width: '16%' }}
          body={subcategory => {
            return (
            <p>{subcategory.service ? localeText('yes'): localeText('no')}</p>)}}
        /> */}
        <Column
          field="descriptionES"
          header={localeText("edit")}
          style={{ width: "20%" }}
          body={(subcategory) => {
            return (
              <Button
                icon="pi pi-pencil"
                onClick={async () => {
                  setIsEdit(false);
                  setDescriptionEnglish(subcategory.descriptionEnglish);
                  setDescriptionItalian(subcategory.descriptionItalian);
                  setDescriptionPortuguese(subcategory.descriptionPortuguese);
                  setDescriptionSpanish(subcategory.descriptionSpanish);
                  setId(subcategory.id);
                  setImageid(subcategory.imageid);
                  setIsService(subcategory.service);

                  await findCategoryToSubcategory(subcategory.id);

                  setIsEdit(true);
                  setTimeout(
                    () => newSubCategoryRef.current.scrollIntoView({ behavior: "smooth" }),
                    100
                  );
                }}
                style={{ textSize: "4em" }}
              />
            );
          }}
        />
      </DataTable>
      <div ref={newSubCategoryRef} id="NewCategories">
        {isEdit && (
          <NewSubcategory
            descriptionEN={descriptionEnglish}
            descriptionES={descriptionSpanish}
            descriptionIT={descriptionItalian}
            descriptionPT={descriptionPortuguese}
            isService={isService}
            id={id}
            images={imageid}
            isEdit={isEdit}
            selectedCategory={selectedCategoryState}
          />
        )}
      </div>
    </div>
  );
};

export default ListSubcategories;
